import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class weatherWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            todayData: {},
            currentWeekData: []
        };
    }
    getForecastsWithinCurrentTime = (forecastData = []) => {
        const currentDateTime = new Date(); // Get the current date and time

        return forecastData.filter(item => {
            const fromDate = new Date(item.fromDate); // Convert fromDate to Date object
            const toDate = new Date(item.toDate); // Convert toDate to Date object

            // Check if the current date and time is within the fromDate and toDate
            return currentDateTime >= fromDate && currentDateTime <= toDate;
        });
    }




     getCurrentWeekData(groupedData) {
        // Get the current date
        const now = new Date();
        const dayOfWeek = now.getUTCDay(); // 0 (Sunday) to 6 (Saturday)
    
        // Calculate the start (Monday) and end (Sunday) of the current week
        const mondayOfWeek = new Date(now);
        mondayOfWeek.setUTCDate(now.getUTCDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));
        mondayOfWeek.setUTCHours(0, 0, 0, 0);
    
        const sundayOfWeek = new Date(mondayOfWeek);
        sundayOfWeek.setUTCDate(mondayOfWeek.getUTCDate() + 6);
        sundayOfWeek.setUTCHours(23, 59, 59, 999);
    
        const currentWeekData = [];
    
        // Iterate over each date in groupedData and check if it falls within the current week
        for (const dateKey in groupedData) {
            const date = new Date(dateKey);
    
            // If the date falls within the current week, add the first data entry of that day to the result
            if (date >= mondayOfWeek && date <= sundayOfWeek) {
                currentWeekData.push(groupedData[dateKey][0]); // Add only the first item for each date
            }
        }
    
        return currentWeekData;
    }
    


    groupForecastDataByDate(forecastData = []) {
        // Create an object to hold data grouped by date
        const groupedData = {};

        // Iterate over each item in forecastData
        forecastData.forEach(item => {
            const dateKey = new Date(item.fromDate).toISOString().split('T')[0]; // Extract the date part (YYYY-MM-DD)

            // If dateKey does not exist in groupedData, initialize it as an empty array
            if (!groupedData[dateKey]) {
                groupedData[dateKey] = [];
            }

            // Add the forecast item to the array for this dateKey
            groupedData[dateKey].push(item);
        });

        // Sort the dates in ascending order and create a new sorted object
        const sortedData = Object.keys(groupedData)
            .sort((a, b) => new Date(a) - new Date(b))
            .reduce((acc, key) => {
                acc[key] = groupedData[key];
                return acc;
            }, {});
        console.log("jjjj", sortedData);

        return sortedData;

    }



    componentDidMount() {
        this.updateTodayData(this.props.weatherInfo.forecast);
    }

    componentDidUpdate(prevProps) {
        // Check if the weatherInfo has changed
        if (prevProps.weatherInfo !== this.props.weatherInfo) {
            this.updateTodayData(this.props.weatherInfo.forecast);
        }
    }

    updateTodayData = (forecast) => {
        const todayData = this.getForecastsWithinCurrentTime(forecast);
        const groupByDate = this.groupForecastDataByDate(forecast)
        const data = this.getCurrentWeekData(groupByDate)
        console.log("mmm",data);
        

        if (todayData.length > 0) {
            this.setState({ todayData: todayData[0] });
        }
        if (Object.keys(data).length > 0) {
            this.setState({ currentWeekData: data });
            console.log("zzzz", data);
        }
    }
    render() {
        const convertCToF = (C) => Math.round((C * 9 / 5) + 32)


        return (
            <div className="weather">
                <div className="weather-title">Weather</div>
                <div className="weather-now">
                    <div className="day-container">
                        <div className="weather-icon">
                            <i className="icon weathericons" dangerouslySetInnerHTML={{ __html: `&#x${this.state.todayData.fontCode};` }}></i>
                        </div>
                        <div className="temp-container">
                            <div className="current-temp">
                                <div className="temp-val">{this.state.todayData.temperature}</div>
                                <div className="temp-sym">&deg;</div>
                                <div className="temp-symbol">C</div>
                            </div>
                            <div className="alt-temp">
                                (<div className="temp-val">{convertCToF(this.state.todayData.temperature)}</div>
                                <div className="temp-sym">&deg;</div>
                                <div className="temp-symbol">F</div>)
                            </div>
                        </div>
                    </div>
                </div>
                <div className="weather-week">
                    <div className="week-container">
                        {Object.values(this.state.currentWeekData).map((entry, index) => (
                            <div className="day-container" key={index}>
                                <div className="weather-icon">
                                    <i className="icon weathericons" dangerouslySetInnerHTML={{ __html: `&#x${entry.fontCode};` }}></i>
                                </div>
                                {/* <div className="temp-container">
                                    <div className="temp-val">{entry.temperature}</div>
                                    <div className="temp-sym">&deg;</div>
                                    <div className="temp-symbol">
                                        {entry.temperatureUnit === 'celsius' ? 'C' : 'F'}
                                    </div>
                                </div> */}
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        );
    }
}

weatherWidget.propTypes = {
    weatherInfo: PropTypes.shape({
        city: PropTypes.shape({
            name: PropTypes.string,
        }),
        forecast: PropTypes.arrayOf(
            PropTypes.shape({
                symbolName: PropTypes.string,
                temperature: PropTypes.number,
                fromDate: PropTypes.string,
                toDate: PropTypes.string,
                temperatureUnit: PropTypes.string,
                fontCode: PropTypes.string,
            })
        ),
    }),
};

weatherWidget.defaultProps = {
    weatherInfo: {
        city: {
            name: 'Unknown City',
        },
        forecast: [],
    },
};

const mapStateToProps = (state) => {
    const weatherData = state.store.home.weatherInfo.data && state.store.home.weatherInfo.data.payload.weather
        ? state.store.home.weatherInfo.data.payload.weather.filter(city => city.city.isDefault)
        : [];

    return {
        weatherInfo: weatherData.length > 0 ? weatherData[0] : {},
    };
};

export default connect(mapStateToProps)(weatherWidget);
